

export enum ShopItemReservationState {
  AWAITING_OPENING = 'AWAITING_OPENING',
  OPENED = 'OPENED',
  PAUSED = 'PAUSED',
  CLOSED = 'CLOSED',
};
